import { parseUrl, stringifyUrl } from 'query-string';

export function setVariantUrlParam(variantId: number|null): void {
    const { url, query } = parseUrl(window.location.href);
    const hash = window.location.hash;

    const newUrl = stringifyUrl({
        url,
        query: {
            ...query,
            variant: variantId,
        }
    }, {
        skipEmptyString: true,
        skipNull: true,
    });

    if (window.history) {
        window.history.replaceState({}, document.title, newUrl + hash);
    }
}
